import { Link, useLocation } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface Props {
  items: BreadcrumbItem[];
  className?: string;
}

export default function Breadcrumb({ items, className }: Props) {
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": item.label,
      "item": item.path ? `https://persianas-malaga.es${item.path}` : undefined,
    })),
  };

  return (
    <nav aria-label="Breadcrumb" className={className || "py-3 md:py-4 bg-background-50 border-b border-background-200/60"}>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <ol className="flex items-center gap-1.5 text-xs md:text-sm flex-wrap">
          {items.map((item, i) => (
            <li key={i} className="flex items-center gap-1.5">
              {i > 0 && (
                <span className="w-3 h-3 flex items-center justify-center text-foreground-400">
                  <i className="ri-arrow-right-s-line text-sm"></i>
                </span>
              )}
              {item.path ? (
                <Link
                  to={item.path}
                  className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {i === 0 && (
                    <span className="w-3.5 h-3.5 inline-flex items-center justify-center mr-1">
                      <i className="ri-home-4-line text-sm"></i>
                    </span>
                  )}
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-900 font-medium whitespace-nowrap">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}